import { LicensingTable } from '../LicensingTable/LicensingTable';
import { ProductCompatibilityTable } from '../ProductCompatibilityTable/ProductCompatibilityTable';
import { PublisherInfoTable } from '../PublisherInfoTable/PublisherInfoTable';
import { Separator } from '../Separator/Separator';
import { ProductNutritionLabelsProps } from './types';

export const ProductNutritionLabels = ({
  compatibility,
  licensing,
  publisher,
  className = '',
}: ProductNutritionLabelsProps) => {
  return (
    <div className={className}>
      <ProductCompatibilityTable {...compatibility} />
      <Separator />
      <LicensingTable {...licensing} />
      <Separator />
      <PublisherInfoTable {...publisher} />
    </div>
  );
};
